import { backofficeUrl, toLocalID } from 'src/shared/helpers';

export const proofingPermission = 'PROOF';

export const proofingRouteId = (id: string) => {
    const localID = toLocalID(id);
    return (localID ?? id).toString();
};

export const proofingRoutes = {
    proofs: () => backofficeUrl('/proofs'),
    proofDetails: (proofId: string) => backofficeUrl(`/proofs/${proofingRouteId(proofId)}`),
    proofVersionDetails: (proofId: string, versionId: string) => backofficeUrl(`/proofs/${proofingRouteId(proofId)}/versions/${proofingRouteId(versionId)}`),
    workflowDefinitions: () => backofficeUrl('/settings/proof-workflows'),
    workflowDefinition: (workflowDefinitionId: string) => backofficeUrl(`/settings/proof-workflows/${proofingRouteId(workflowDefinitionId)}`)
};
